import { connect } from 'react-redux';
import PainelDeRecebiveis from './painelDeRecebiveis';

export default connect()(PainelDeRecebiveis);
